module.exports = __webpack_public_path__ + "static/media/group_document.0b9618e4.svg";